module.exports = __webpack_public_path__ + "static/media/GOAL-BUSD.43e5fb62.png";